import React from "react";
import ReactTooltip from "react-tooltip";

const ToolTip = (props) => (
  <span>
    <span data-tip data-for={props.id} className="custom-info-icon" />
    <ReactTooltip
      id={props.id}
      type="info"
      effect="solid"
      place="right"
      getContent={() => {
        return props.children;
      }}
    />
  </span>
);

export default ToolTip;
